// Velora Marketing - Data

export const BRAND_ASSETS = {
  logo: 'https://customer-assets.emergentagent.com/job_fbbcce8a-0137-450a-bd86-c25e134852b4/artifacts/lz03kewe_f6be628a-6faa-469a-89d1-0c4ba2a0890c.jpeg',
  founderImage: 'https://customer-assets.emergentagent.com/job_fbbcce8a-0137-450a-bd86-c25e134852b4/artifacts/d6uy26ms_57c0f469-ea28-44d5-ab7e-a54e5184716c.jpeg',
};

export const NAVIGATION = [
  { name: 'Home', path: '/' },
  { name: 'Work', path: '/work' },
  { name: 'Perspective', path: '/perspective' },
  { name: 'Contact', path: '/contact' },
];

export const CLIENTS = [
  'Biosil Beauty',
  'Nobel Biocare',
  'Noble Hospitals',
  'The Times of India',
  'Astrotalk',
  'Mamaearth',
  'Phool.co',
  'Fiona Diamonds',
];

export const SERVICES = [
  {
    id: 'brand-identity',
    title: 'Brand Identity & Positioning',
    description: 'We don\'t just design logos. We architect the soul of your brand — the invisible thread that makes people feel something before they understand why. Positioning that doesn\'t compete, but commands.',
  },
  {
    id: 'web-presence',
    title: 'Premium Web Presence',
    description: 'Your digital home should feel like walking into a room that was designed for you. We build websites that don\'t just function — they seduce, hold attention, and convert conviction into action.',
  },
  {
    id: 'social-elevation',
    title: 'Social Media Elevation',
    description: 'Beyond likes and follows lies influence. We craft social presence that builds cultural relevance — content that earns attention, not begs for it. Presence that positions you as the authority.',
  },
  {
    id: 'growth-momentum',
    title: 'Growth Momentum',
    description: 'Growth isn\'t noise. It\'s direction. We engineer momentum through strategic campaigns, precision targeting, and data-informed decisions that compound — because real growth is designed, not chased.',
  },
];

export const HOW_WE_WORK = [
  {
    step: '01',
    title: 'We Begin With Understanding',
    description: 'Conversation first. Listening before strategy.',
  },
  {
    step: '02',
    title: 'We Design the Direction',
    description: 'Clarity over chaos. Structure before scale.',
  },
  {
    step: '03',
    title: 'We Build With Precision',
    description: 'Branding, websites, campaigns — executed calmly and deliberately.',
  },
];

export const CASE_STUDIES = [
  {
    id: 'healthcare',
    title: 'Healthcare & Medical Institutions',
    description: 'Positioned healthcare brands to command trust, precision, and authority in highly regulated markets.',
    category: 'Brand Strategy • Positioning • Authority',
    challenge: 'Navigating trust-sensitive decision-making, regulatory complexity, and credibility at scale.',
    approach: 'Precision-led positioning informed by medical insight, audience psychology, and long-term brand equity.',
    outcome: 'Established authority, trust, and sustained influence in high-stakes environments.',
    clients: ['Nobel Biocare', 'Rainbow Superspeciality Hospital', 'Hinjawadi Superspeciality Hospital', 'Noble Hospitals'],
    cardStatement: 'Positioning brands where trust decides outcomes.',
  },
  {
    id: 'global-consumer',
    title: 'Global Consumer & Lifestyle Brands',
    description: 'Positioned consumer & lifestyle brands to scale across markets without losing identity or cultural relevance.',
    category: 'Brand Strategy • Positioning • Authority',
    challenge: 'Balancing growth, differentiation, and consistency across competitive and evolving markets.',
    approach: 'Strategic positioning guided by cultural insight, audience behavior, and brand longevity.',
    outcome: 'Built enduring brand authority that translated into measurable growth.',
    clients: ['Biosil Beauty', 'Mama-earth', 'Premium D2C Brands (Confidential)'],
    cardStatement: 'Clarity before scale. Always.',
  },
  {
    id: 'media',
    title: 'Media, Platforms & Culture',
    description: 'Strengthened platform authority and narrative control across high-visibility media ecosystems.',
    category: 'Brand Strategy • Positioning • Authority',
    challenge: 'Maintaining narrative authority while operating at speed, scale, and public scrutiny.',
    approach: 'Narrative-first strategy designed to influence perception, reach, and trust.',
    outcome: 'Reinforced leadership, visibility, and long-term platform relevance.',
    clients: ['The Times of India', 'AstroTalk', 'Ankur Warikoo', 'Platform-led Media Brands'],
    cardStatement: 'Authority isn\'t claimed. It\'s earned over time.',
  },
  {
    id: 'technology',
    title: 'Technology & Innovation',
    description: 'Clarified product positioning to drive adoption, credibility, and long-term category leadership.',
    category: 'Brand Strategy • Positioning • Authority',
    challenge: 'Translating innovation into clarity, relevance, and market confidence.',
    approach: 'Clarity-driven positioning aligned with product truth and market readiness.',
    outcome: 'Delivered market confidence, adoption momentum, and strategic differentiation.',
    clients: ['SaaS & Innovation-Driven Platforms (Confidential)'],
    cardStatement: 'Built for longevity, not attention.',
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    quote: "Ashwini's thinking changed our direction – not just our campaigns. She brought clarity where complexity was the norm, and authority where trust mattered most.",
    author: 'Dr. Amol Gholap',
    role: 'Director, Hinjawadi Superspeciality Hospital',
  },
  {
    id: 2,
    quote: "Working with Ashwini felt less like hiring a consultant and more like aligning with conviction. Every decision was intentional, strategic, and deeply thought through.",
    author: 'Nandkumar Jorwekar',
    role: 'Director – Skyline MEP Consultants',
  },
  {
    id: 3,
    quote: "Velora doesn't execute marketing. They define how a brand should exist – and then make the market believe it.",
    author: 'Executive Brand Manager',
    role: 'Biosil Beauty',
  },
  {
    id: 4,
    quote: "Ashwini has a rare ability to translate leadership, experience, and vision into language that carries weight. Her writing doesn't just tell stories – it establishes authority.",
    author: 'Vikesh Walia',
    role: 'Board member, The Times of India Group',
  },
  {
    id: 5,
    quote: "Ashwini understands storytelling at a level most professionals don't. She captures achievements with precision, depth, and narrative strength that holds attention till the last line.",
    author: 'Kaushal Ottem',
    role: 'Technology Innovator & Thought Leader',
  },
];

export const FOUNDER = {
  name: 'Ashwini Ratnaparkhi',
  title: 'CEO, Velora Marketing',
  image: BRAND_ASSETS.founderImage,
  philosophy: "I don't believe brands win by doing more. They win by seeing clearly — before others do. Velora was built on that principle.",
  worldview: [
    'Perception is the only reality that matters in business.',
    'The best brands don\'t chase attention. They command presence.',
    'Growth follows clarity. Always.',
    'Authority cannot be manufactured. It can only be cultivated.',
  ],
};

export const CONTACT_INFO = {
  email: 'Ashwini.veloramarketing@gmail.com',
  phone: '+91 8208377252',
  office: 'Baner, Pune, India – 411045',
};
